var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon bubble") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Journey-0---Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.5--Dashboard---empty-state",
    transform: "translate(-700.000000, -242.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(469.000000, 242.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-bubble",
    transform: "translate(231.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 9,
    cy: 9,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0.3,
    fill: "#1DDCC0",
    cx: 9,
    cy: 9,
    r: 9
  })), /*#__PURE__*/React.createElement("g", {
    id: "check-circle",
    transform: "translate(3.857143, 3.857143)",
    fill: "#1DDCC0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.54171429,3.492 L4.33542857,5.70342857 L3.48685714,4.85485714 C3.36117092,4.70809226 3.16382483,4.64416357 2.97595596,4.68935479 C2.78808709,4.734546 2.64140315,4.88122995 2.59621193,5.06909881 C2.55102071,5.25696768 2.6149494,5.45431378 2.76171429,5.58 L3.97028571,6.79371429 C4.06734111,6.88998164 4.19872989,6.94364748 4.33542857,6.94285714 C4.47034622,6.94228905 4.59963739,6.88872557 4.69542857,6.79371429 L7.26685714,4.22228571 C7.36421793,4.12572003 7.418982,3.99427073 7.418982,3.85714286 C7.418982,3.72001498 7.36421793,3.58856568 7.26685714,3.492 C7.06626645,3.29259929 6.74230498,3.29259929 6.54171429,3.492 Z M5.14285714,2.28388736e-16 C2.30253557,-1.14194368e-16 2.28388736e-16,2.30253557 0,5.14285714 C-2.28388736e-16,7.98317871 2.30253557,10.2857143 5.14285714,10.2857143 C7.98317871,10.2857143 10.2857143,7.98317871 10.2857143,5.14285714 C10.2857143,3.77888662 9.74387911,2.47078079 8.7794063,1.50630798 C7.8149335,0.541835179 6.50682766,1.14194368e-16 5.14285714,2.28388736e-16 Z M5.14285714,9.25714286 C2.87059989,9.25714286 1.02857143,7.4151144 1.02857143,5.14285714 C1.02857143,2.87059989 2.87059989,1.02857143 5.14285714,1.02857143 C7.4151144,1.02857143 9.25714286,2.87059989 9.25714286,5.14285714 C9.25714286,6.23403356 8.82367471,7.28051823 8.05209647,8.05209647 C7.28051823,8.82367471 6.23403356,9.25714286 5.14285714,9.25714286 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.7968b7789a1688f7d0147b613d7aa162.svg";
export { ForwardRef as ReactComponent };